import UltMeta, { Meta } from "@/meta/UltMeta/index";

class ReceivedStatus extends UltMeta {
    TRANSFER = new Meta(1, "转账中");
    TRANSFERFAIL = new Meta(2, "转账失败");
    TRANSFERSUCCESS = new Meta(3, "转账成功");
    NOT_SETTLE = new Meta(4, "待结算");
    SETTLED = new Meta(5, "已结算");
}

export const RECEIVED_STATUS = new ReceivedStatus();

class CompletionStatus extends UltMeta {
    UNSETTLED = new Meta(1, "未完成");
    INCOMPLETE = new Meta(2, "已完成");
}

export const COMPLETION_STATUS = new CompletionStatus();

class LinePaymentMethod extends UltMeta {
    ONLINE = new Meta(1, "自行支付");
    OFFLINE = new Meta(2, "服务商垫付(黄码港网络货运平台)");
    PAY_EASY_SIGN = new Meta(3, "服务商垫付(签好运网络货运平台)");
}

export const LINE_PAYMENT_METHOD = new LinePaymentMethod();

class PayTypeName extends UltMeta {
    ONLINE = new Meta(1, "自行支付");
    OFFLINE = new Meta(2, "黄码港网络货运平台");
    PAY_EASY_SIGN = new Meta(3, "签好运网络货运平台");
}

export const PAY_TYPE_NAME = new PayTypeName();

class PaymentState extends UltMeta {
    CONFIRMING = new Meta(1, "待确认");
    CONFIRMED = new Meta(2, "已确认");
}

export const PAYMENT_STATE = new PaymentState();
